
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMortgagePurchaseOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanPurpose"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creditBand"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanAmount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyUse"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"downPaymentPercent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ltvPercent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"filteredMortgageOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loanPurpose"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanPurpose"}}},{"kind":"Argument","name":{"kind":"Name","value":"creditBand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creditBand"}}},{"kind":"Argument","name":{"kind":"Name","value":"loanAmount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanAmount"}}},{"kind":"Argument","name":{"kind":"Name","value":"propertyUse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyUse"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"loanType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanType"}}},{"kind":"Argument","name":{"kind":"Name","value":"downPaymentPercent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"downPaymentPercent"}}},{"kind":"Argument","name":{"kind":"Name","value":"ltvPercent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ltvPercent"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lenderId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lenderShortName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loanProgram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productCategory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"propertyUse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loanAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minInterestRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthlyPayment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minAPR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxAPR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minInterestRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxInterestRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthlyPayment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loanTermMonths"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medianInterestRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lenderLogo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lenderUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selfGradedCredit"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1168}};
    doc.loc.source = {"body":"# Personal Loan Lenders Offers\n# Variables:\n#  - $loanAmtBand - Integer - Loan Amount Band\n#  - $creditBand - Integer - Credit Score Band\n#  - $loanPurpose - Non-nullable string - Loan Purpose\n#  - $state - Non-nullable string - State abbreviation\n\n# LimitQuery1Unit - Return all the PL offers\nquery getMortgagePurchaseOffers($loanPurpose: String!, $creditBand: String!, $loanAmount: Int!, $propertyUse: String!, $state: String!, $loanType: String!, $downPaymentPercent: Decimal!, $ltvPercent: Decimal!) {\n    result: filteredMortgageOffer(loanPurpose: $loanPurpose, creditBand: $creditBand, loanAmount: $loanAmount\n        , propertyUse: $propertyUse, state: $state, loanType: $loanType, downPaymentPercent: $downPaymentPercent, ltvPercent: $ltvPercent) {\n        lenderId    \n        lenderShortName \n        state \n        loanProgram\n        productCategory\n        propertyUse\n        loanAmount\n        minInterestRate\n        monthlyPayment\n        minAPR\n        maxAPR\n        minInterestRate\n        maxInterestRate\n        monthlyPayment\n        loanTermMonths\n        medianInterestRate\n        lenderLogo\n        lenderUrl\n        selfGradedCredit\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getMortgagePurchaseOffers"] = oneQuery(doc, "getMortgagePurchaseOffers");
        
